module.exports = __webpack_public_path__ + "media/images/hero_header/hero_header3-955d195ca49876b8a91cc537b8698c04.jpeg";